import React, { Component } from 'react'
import '../styles/Tombeau.css'
import Navbar from './Navbar'
import BookingContainer from './BookingContainer'
import Footer from './Footer'
import LACover from '../images/Themes/LA/la-cover.jpg'
import TombeauCover from '../images/Themes/Tombeau/Tombeau-cover.jpg'
import TombeauCoverMobile from '../images/Themes/Tombeau/mobile-tombeau-cover.jpg'
import TombeauVideo from '../images/Themes/Tombeau/Tombeau-cover-video.jpg'
import TombeauIcon from '../images/Themes/icon-tombeau.png'
import TombeauPicture1 from '../images/Themes/Tombeau/Tombeau-picture-1.jpg'
import TombeauPicture2 from '../images/Themes/Tombeau/Tombeau-picture-2.jpg'
import TombeauPicture3 from '../images/Themes/Tombeau/Tombeau-picture-3.jpg'
import VBNPicture1 from '../images/Themes/VBN/vbn-picture-1.jpg'
import AbattoirPicture1 from '../images/Themes/Abattoir/abattoir-picture-1.jpg'
import YakuzaPicture1 from '../images/Themes/Yakuza/yakuza-picture-1.jpg'
import MagnifierIcon from '../images/Themes/magnifier-icon.png'
import GlobeIcon from '../images/Themes/globe-icon.png'
import StarIcon from '../images/Themes/star-icon.png'
import PlayerIcon from '../images/Themes/player-icon.png'
import BrainEmoji from '../images/Themes/Tombeau/brain-emoji.png'
import { Link } from 'react-router-dom'
import ReactPlayer from 'react-player'
import { injectIntl, defineMessages } from 'react-intl'
import Helmet from 'react-helmet'


const BackgroundUrl = `url(${TombeauCover})`;
const BackgroundUrlMobile = `url(${TombeauCoverMobile})`;

const removeTransition = (element) => {
  element.classList.remove("site-transition--visible")
}

class Tombeau extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isTop: true,
      videoPlaying: false,
      smallVideoPlaying: false
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 100;
      if (isTop !== this.state.isTop) {
          this.setState({ isTop })
      }
    })

    const glitchTransition = document.getElementById("site-transition")
    window.setTimeout(() => {
      glitchTransition.classList.add("site-transition--visible")
      window.setTimeout(() => {
        removeTransition(glitchTransition)
      }, 500)
    }, 10)
  }
  render() {
    const {intl:{formatMessage}} = this.props
    return (
      <div className="theme lost-asylum">
        <Helmet>
          <title>{formatMessage(messages.Tombeau)}</title>
          <meta name="description" content={formatMessage(messages.TombeauMeta)} />
			<meta property="og:type" content="website"/>
			<meta property="og:url" content="https://www.one-hour.fr/expedition-maudite/"/>
			<meta property="og:title" content="L'expédition maudite"/>
			<meta property="og:description" content="Vous êtes un groupe d’aventuriers partis à la recherche d’explorateurs perdus dans une vieille mine."/>
			<meta property="og:image" content="https://www.one-hour.fr/static/media/OHpresse30.jpg"/>
			<meta property="twitter:card" content="summary_large_image"/>
			<meta property="twitter:url" content="https://www.one-hour.fr/expedition-maudite/"/>
			<meta property="twitter:title" content="L'expédition maudite"/>
			<meta property="twitter:description" content="Vous êtes un groupe d’aventuriers parti à la recherche d’explorateurs perdus dans une vieille mine."/>
			<meta property="twitter:image" content="https://www.one-hour.fr/static/media/OHpresse30.jpg"/>
			<link rel="apple-touch-icon" href="https://www.one-hour.fr/static/media/apple-touch-icon.png" />
			<html lang="fr" />
        </Helmet>
        <div className="theme-hero">
          <Navbar
            isTop={this.state.isTop}
            handleLang={(lang) => this.props.handleLang(lang)}
            lang={this.props.lang}
            />
          <div className="theme-hero-cover theme-d-background" style={{ '--background-url': BackgroundUrl, '--background-url-mobile':BackgroundUrlMobile }}>
          {
            this.state.videoPlaying
            ?
              <ReactPlayer
                url='https://www.youtube.com/watch?v=7FuxM_4Lh8Y'
                playing
                width="100%"
                height="100%"
                controls={false}
                onEnded={() => this.setState({ videoPlaying: false })}
                config={
                  {
                    youtube: {
                      controls: 0,
                      showInfo: 0
                    }
                  }
                } />
              : null
          }
          </div>
          {
            !this.state.videoPlaying
            ?
            <div className="theme-title">
              <div className="theme-logo" style={{ backgroundImage: `url(${TombeauIcon})`}}></div>
              <div className="title">{formatMessage(messages.titre)}</div>
              <div className="play-video-button" onClick={() => this.setState({ videoPlaying: true })}>
                <span>{formatMessage(messages.playVideo)}</span>
                <span className="play-video-icon">
                  <i className="fas fa-play"></i>
                </span>
              </div>
            </div>
            : null
          }
          {
            !this.state.videoPlaying
            ?
              <div className="theme-infobar">
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.genre)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.genreInfo)}</div>
                  <div className="theme-infobar-icon"><img src={MagnifierIcon} alt="" /></div>
                </div>
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.difficulty)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.difficultyInfo)}</div>
                  <div className="theme-infobar-icon"><img src={StarIcon} alt="" /></div>
                </div>
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.players)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.playersInfo)}</div>
                  <div className="theme-infobar-icon"><img src={PlayerIcon} alt="" /></div>
                </div>
                <div className="theme-infobar-unit">
                  <div className="theme-infobar-parameter">{formatMessage(messages.language)}</div>
                  <div className="theme-infobar-data">{formatMessage(messages.languageInfo)}</div>
                  <div className="theme-infobar-icon"><img src={GlobeIcon} alt="" /></div>
                </div>
              </div>
            : null
          }
        </div>
        <div className="theme-presentation-text-wrapper">
          <div className="theme-presentation-text">
		    <h1>{formatMessage(messages.titreh1)}</h1>
            <p>{formatMessage(messages.presentationText1)}</p>
            <p>{formatMessage(messages.presentationText2)}</p>
            <p>{formatMessage(messages.presentationText3)}</p>
            <div className="theme-presentation-disclaimer">
              <img alt="" src={BrainEmoji} />
              <span>{formatMessage(messages.disclaimer)}</span>
            </div>
          </div>
        </div>
        <div className="theme-gallery-container">
          <span className="theme-gallery-label">{formatMessage(messages.gallery)}</span>
          <div className="theme-gallery">
            <div className="theme-gallery-testimonial">
              <p className="theme-gallery-testimonial-comment">{formatMessage(messages.testimonalComment)}</p>
              <p className="theme-gallery-testimonial-author">
                <span>{formatMessage(messages.testimonalAuthor)}</span>
                <i className="fab fa-tripadvisor"></i>
              </p>
            </div>
            <div
              className="theme-gallery-image theme-gallery-video"
              style={{backgroundImage: `url(${TombeauVideo})`}}
              >
              {
                this.state.smallVideoPlaying
                ?
                  <ReactPlayer
                    url='https://www.youtube.com/watch?v=7FuxM_4Lh8Y'
                    playing
                    width="100%"
                    height="100%"
                    controls={false}
                    onEnded={() => this.setState({ smallVideoPlaying: false })}
                    config={
                      {
                        youtube: {
                          controls: 0,
                          showInfo: 0
                        }
                      }
                    } />
                : <div style={{ width: "100%", height: "100%", position: "relative"}}>
                    <span
                      className="theme-gallery-play-button"
                      onClick={() => this.setState({ smallVideoPlaying: true })}
                      >►</span>
                  </div>
              }
              </div>
            <div
              style={{backgroundImage: `url(${TombeauPicture1})`}}
              className="theme-gallery-image theme-gallery-picture-1"></div>
            <div
              style={{backgroundImage: `url(${TombeauPicture2})`}}
              className="theme-gallery-image theme-gallery-picture-2"></div>
            <div
              style={{backgroundImage: `url(${TombeauPicture3})`}}
              className="theme-gallery-image theme-gallery-picture-3"></div>
          </div>
        </div>
        <BookingContainer
          theme="tombeau"
          lang={this.props.lang}
          expiration={() => this.props.handleExpiration()}/>
		<div className="theme-content">
		  <p>
		    <p>
		    {formatMessage(messages.agemini)}
		    </p>
		    <h2>{formatMessage(messages.titreh1)}</h2>
			{formatMessage(messages.presentationseo)}
			<h2>Les récompenses reçues</h2>
			L'Expédition Maudite a reçu plusieurs récompenses depuis sa création :
			<ul>
				<li>Top Golden Escape 2023 et 2024</li>
				<li>Top 3 Escape game Awards 2024</li>
				<li>Best of Morty 2023 et 2024</li>
				<li>Top meilleur escape game du monde (TERPECA) 2022 2023 et 2024</li>
				<li>Prix Traveller's choice Tripadvisor 2022</li>
			</ul>
		  </p>
		</div>
        <div className="theme-other-themes">
          <h3>{formatMessage(messages.discoverOurOtherThemes)}</h3>
          <div className="theme-other-themes-container">
            <Link to="/lost-asylum/">
              <div className="theme-other-themes-card">
                <div className="theme-other-themes-picture" style={{ backgroundImage: `url(${LACover})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.lostAsylum)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.laBaseline)}</span>
                </div>
              </div>
            </Link>
            <Link to="/very-bad-night/">
              <div className="theme-other-themes-card theme-other-themes-card--vbn">
                <div className="theme-other-themes-picture theme-other-themes-card--vbn" style={{ backgroundImage: `url(${VBNPicture1})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.VBN)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.VBNBaseline)}</span>
                </div>
              </div>
            </Link>
            <Link to="/abattoir/">
              <div className="theme-other-themes-card">
                <div className="theme-other-themes-picture" style={{ backgroundImage: `url(${AbattoirPicture1})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.slaughterhouse)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.slaughterhouseBaseline)}</span>
                </div>
              </div>
            </Link>
            <Link to="/yakuza/">
              <div className="theme-other-themes-card theme-other-themes-card--yakuza">
                <div className="theme-other-themes-picture theme-other-themes-card--yakuza" style={{ backgroundImage: `url(${YakuzaPicture1})`}} />
                <div className="theme-other-themes-card-text">
                  <h4>{formatMessage(messages.yakuza)}</h4>
                  <span className="theme-other-themes-baseline">{formatMessage(messages.yakuzaBaseline)}</span>
                </div>
              </div>
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

const messages = defineMessages({
  playVideo: {
    id: 'themes.playVideo',
    defaultMessage: 'Lancer la vidéo'
  },
  genre: {
    id: 'themes.genre',
    defaultMessage: 'Genre'
  },
  difficulty: {
    id: 'themes.difficulty',
    defaultMessage: 'Difficulté'
  },
  players: {
    id: 'themes.players',
    defaultMessage: 'Joueurs'
  },
  language: {
    id: 'themes.language',
    defaultMessage: 'Langue'
  },
  genreInfo: {
    id: 'Tombeau.genre',
    defaultMessage: 'Aventure / Frisson'
  },
  difficultyInfo: {
    id: 'Tombeau.difficulty',
    defaultMessage: 'Tous niveaux'
  },
  playersInfo: {
    id: 'Tombeau.players',
    defaultMessage: 'de 1 à 6 joueurs'
  },
  languageInfo: {
    id: 'Tombeau.language',
    defaultMessage: 'Français / Anglais'
  },
  titre: {
    id: 'Tombeau.titre',
    defaultMessage: 'L’Expédition Maudite'
  },
  titreh1: {
    id: 'Tombeau.titreh1',
    defaultMessage: 'Escape game aventure à Paris'
  },
  presentationText1: {
    id: 'Tombeau.presentationText1',
    defaultMessage: 'Vous êtes un groupe d’aventuriers parti à la recherche d’explorateurs perdus dans une vieille mine.'
  },
  presentationText2: {
    id: 'Tombeau.presentationText2',
    defaultMessage: 'Cette aventure vous emmènera au travers de chemins tortueux dans des lieux fantastiques où personne n’a mis les pieds depuis des milliers d’années.'
  },
  presentationText3: {
    id: 'Tombeau.presentationText3',
    defaultMessage: 'Mais attention… certaines rumeurs racontent que le chemin pour y parvenir sera peut être plus compliqué que prévu'
  },
  presentationseo: {
    id: 'Tombeau.presentationseo',
    defaultMessage: 'L’expédition maudite est la salle aventure de One Hour. Incarnez un véritable aventurier au fin fond d’une mystérieuse mine perdue. Cet escape game va vous émerveiller de par ses décors et les multiples découvertes que votre équipe va découvrir. L’expédition maudite comporte aussi une bonne dose de frisson : de nombreux pièges disséminés testeront votre courage et votre réflexion.'
  },
  agemini: {
    id: 'Tombeau.agemini',
    defaultMessage: 'L’âge minimum pour participer à une session chez One Hour est de 14 ans. Nous conseillons de faire des équipes de 2 à 5 joueurs. ⚠️ À 6 le jeu sera moins intense et confortable.'
  },
  disclaimer: {
    id: 'Tombeau.disclaimer',
    defaultMessage: 'Prévoir vêtements confortables. Déconseillé aux femmes enceintes et aux personnes ayant des problèmes de dos / genoux'
  },
  gallery: {
    id: 'themes.gallery',
    defaultMessage: 'Galerie'
  },
  testimonalComment: {
    id: 'Tombeau.testimonalComment',
    defaultMessage: 'Un escape game DINGUE ! Des décors incroyables, des manipulations inédites et des effets spéciaux jamais vus !'
  },
  testimonalAuthor: {
    id: 'Tombeau.testimonalAuthor',
    defaultMessage: 'ChrisNorris, Paris, France'
  },
  discoverOurOtherThemes: {
    id: 'themes.discoverOurOtherThemes',
    defaultMessage: 'Découvrez nos autres thèmes escape game Paris :'
  },
  slaughterhouseBaseline: {
    id: 'themesContainer.slaughterhouseBaseline',
    defaultMessage: 'ça va trancher chérie'
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Yakuza"
  },
  Tombeau: {
    id: 'themes.tombeau',
    defaultMessage: "L'Expédition Maudite"
  },
  VBN: {
    id: 'themes.VBN',
    defaultMessage: "Very Bad Night"
  },
  VBNBaseline: {
    id: 'themesContainer.vbnBaseline',
    defaultMessage: "Une gueule de bois marathon"
  },
  slaughterhouseBaseline: {
    id: 'themesContainer.slaughterhouseBaseline',
    defaultMessage: 'ça va trancher chérie'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: "L'abattoir"
  },
  lostAsylum: {
    id: 'themes.la',
    defaultMessage: "Lost Asylum"
  },
  laBaseline: {
    id: 'themesContainer.laBaseline',
    defaultMessage: "Echappez-vous avant de devenir fou"
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Yakuza"
  },
  yakuzaBaseline: {
    id: 'themesContainer.yakuzaBaseline',
    defaultMessage: "Une gueule de bois marathon"
  },
  TombeauMeta: {
    id: 'themes.TombeauMeta',
    defaultMessage: "Vous êtes un groupe d’aventuriers partis à la recherche d’explorateurs perdus dans une vieille mine."
  },
})

export default injectIntl(Tombeau)



// WEBPACK FOOTER //
// ./src/components/Tombeau.js